module.exports = __webpack_public_path__ + "static/devices-pattern.1ac28cee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/devices-pattern.jpg
// module id = 727
// module chunks = 35783957827783